var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Table, TableProvider, translate, Typography, } from '@lucidlink/uicore';
import { metricToString } from '../../../../services';
const COLUMN_CONFIG_LIST = [
    {
        columnGrow: 'flex',
        id: 'name',
        label: 'Name',
        renderData: (metric) => (_jsx(Typography, { color: "default", kind: "p", children: metric.name })),
    },
    {
        columnGrow: 'flex',
        id: 'value',
        label: 'Value',
        renderData: (metric) => (_jsx(Typography, { color: "default", kind: "p", children: metricToString(metric.value) })),
    },
];
const dataIdAccessor = (metric) => {
    return metric.name;
};
export const MetricsTable = ({ data }) => {
    return (_jsx(TableProvider, { children: _jsx(Table, { columnConfigList: COLUMN_CONFIG_LIST, data: data, "data-testid": "metrics-table", dataIdAccessor: dataIdAccessor, isScrollable: true, loadingLabel: translate('Loading metrics') }) }));
};
_react_refresh_temp_1 = MetricsTable;
$RefreshReg$(_react_refresh_temp_1, "MetricsTable");
